/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Prep_DigestInputs */



/**
* | output |
* | --- |
* | "Daily overview of your conversations" |
*
* @param {Notifications_Prep_DigestInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const notifications_prep_digest = /** @type {((inputs?: Notifications_Prep_DigestInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Prep_DigestInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Dagelijks overzicht van je gesprekken")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aperçu quotidien de vos conversations")
	return /** @type {LocalizedString} */ ("Daily overview of your conversations")
});